import { useGlobalAuth } from '@headbox-ui/auth-hook'
import React, { ReactElement } from 'react'
import { s } from './style'
import { FavouriteIcon } from './FavouriteIcon'
import { HasPreferredVenueContentWrapperProposalFragment } from './HasPreferredVenueContentWrapper.generated-types'

interface HasPreferredVenueContentWrapperProps {
  proposal: HasPreferredVenueContentWrapperProposalFragment
  children: ReactElement
}

const ContentWrapper = (children: React.ReactNode, companyName?: string): ReactElement => (
  <div style={s.wrapper}>
    <div style={s.contentsContainer}>
      <div style={s.iconContainer}>
        <FavouriteIcon></FavouriteIcon>
      </div>
      <div>
        <div style={s.companyFavouriteText}>{`${
          companyName != null ? companyName : "My company's"
        } favourite`}</div>
        <div style={s.bookersText}>Bookers in your company love this venue</div>
      </div>
    </div>
    <div style={s.childrenContainer}>{children}</div>
  </div>
)

export const HasPreferredVenueContentWrapper = ({
  proposal,
  children,
}: HasPreferredVenueContentWrapperProps): ReactElement => {
  const { user } = useGlobalAuth()

  return proposal.hasPreferredVenue ? ContentWrapper(children, user.companyName) : children
}
